/**
 * Dummy listings for local development only.
 *
 * Activated by VITE_DUMMY_LISTINGS=true in .env.local (gitignored).
 * In production builds import.meta.env.DEV is false, so this never activates.
 */

const DUMMY_ENABLED =
  import.meta.env.DEV && import.meta.env.VITE_DUMMY_LISTINGS === "true";

const PLACEHOLDER = "https://placehold.co/600x600/111/333?text=";

const BRANDS = [
  { name: "Chrome Hearts", id: "brand-ch" },
  { name: "Rick Owens", id: "brand-ro" },
  { name: "Balenciaga", id: "brand-bal" },
  { name: "Number (N)ine", id: "brand-n9" },
  { name: "Vetements", id: "brand-vet" },
];

function makeDummyItems() {
  const items = [];
  let counter = 1;

  for (const brand of BRANDS) {
    // Give every brand 6–12 items so they pass the MIN_ITEMS=5 filter on /brand
    const count = 6 + Math.floor(Math.random() * 7);
    for (let i = 0; i < count; i++) {
      const id = `dummy-${counter}`;
      const price = Math.round((200 + Math.random() * 2800) / 50) * 50;
      items.push({
        id,
        title: `Dummy Item #${counter}`,
        brand_name: brand.name,
        brand_id: brand.id,
        brand: brand.name,
        price_usd: price,
        original_price_usd: null,
        price_adjusted: false,
        photos_json: [
          { url: `${PLACEHOLDER}${encodeURIComponent(`#${counter}+A`)}` },
          { url: `${PLACEHOLDER}${encodeURIComponent(`#${counter}+B`)}` },
        ],
        cover_index: 0,
        state: "LIVE",
        sold: false,
        is_available: true,
        // Every 5th item goes to the Showcase page instead of the catalog
        showcase: counter % 5 === 0,
        description: `Development placeholder item ${counter}`,
        size: ["S", "M", "L", "XL"][Math.floor(Math.random() * 4)],
        color: null,
      });
      counter++;
    }
  }
  return items;
}

let _dummyItems = null;

/** Returns dummy items array (stable across calls). */
export function getDummyItems() {
  if (!DUMMY_ENABLED) return null;
  if (!_dummyItems) _dummyItems = makeDummyItems();
  return _dummyItems;
}

/** True when dummy listings are active. */
export const isDummyEnabled = DUMMY_ENABLED;

/**
 * Wraps a fetch call so that inventory API requests return dummy data in dev.
 * Usage: const res = await dummyFetch(url, opts)  — drop-in fetch replacement.
 */
export function dummyFetch(url, opts) {
  if (!DUMMY_ENABLED) return fetch(url, opts);

  const urlStr = typeof url === "string" ? url : url.toString();
  if (urlStr.includes("/api/inventory")) {
    const items = getDummyItems();
    return Promise.resolve({
      ok: true,
      json: () => Promise.resolve({ items }),
    });
  }
  if (urlStr.includes("/api/views/popular")) {
    return Promise.resolve({
      ok: true,
      json: () => Promise.resolve([]),
    });
  }
  // Fall through to real fetch for other endpoints
  return fetch(url, opts);
}
